import React, { useEffect, useState, useRef } from 'react'
// bootstrap
import { Carousel, } from 'react-bootstrap';
// Services
import ActiveService from '../../../services/active';
import GeneralService from '../../../services/general';
import WorkerService from '../../../services/worker';
// Functions
import { CODES } from '../../../utils/responseCodes';
import { Toast } from '../../../utils/alerts';
// Components
import Loader from '../../components/Spinner/Loader';
import MainInput from '../../components/general/MainInput';
import MainInputImage from '../../components/general/MainInputImage';
import DynamicTitle from '../../../utils/DynamicTitle';
import MainSelect from '../../components/general/MainSelect';
import MainSelectPlus from '../../components/general/MainSelectPlus';
// ... (IMPORTS IGUALES)
const newEquipo = {
    id_jefe:'',
    telfJefe:'',
    propiedad: '',
    id_centroCosto: '',
    centroCosto: '',
    marca: '',
    modelo: '',
    persona_id: '',
    numdoc: '',
    nombres: '',
    apellidos: '',
    serial: '',
    otros: '',
    id_tipoEquipo: '',
    id_tipoEquipoOtro:'',
    codigoEquipo: '',
    id_estadoEquipo: '',
    departamento: '',
    distrito: '',
    direccion: '',
    lugar: '',
    tiempoVidaAnios: '',
    tiempoVidaMeses: '',
    imagen_marca: null,
    imagen_modelo: null,
    imagen_serial: null,
};


const EquipmentRegister = () => {
    const [openLoader, setOpenLoader] = useState(false);
    const [messageLoader, setMessageLoader] = useState(null);

    const [imageGeneral, setImageGeneral] = useState([]);
    const [fileGeneral, setFileGeneral] = useState(null);

    const [formData, setFormData] = useState(newEquipo);
    console.log("🚀 ~ EquipmentRegister ~ formData:", formData)
    const [tipoEquipo, setTipoEquipo] = useState([]);
    const [tipoEquipoMin, setTipoEquipoMin] = useState(null);
    const [estadoEquipo, setEstadoEquipo] = useState(null);
    const [centroCosto, setCentroCosto] = useState(null);
    const [jefes, setJefes] = useState(null);

    const [jefesWorker, setJefesWorker] = useState(null);
    const [isPersonFound, setIsPersonFound] = useState(false);

    const tipoEquipoConOtros = Array.isArray(tipoEquipo)
        ? [
            ...tipoEquipo,
            {
                id: 9999,
                id_tipoEquipo: 9999,
                desTipoEquipo: 'OTROS',
                value: 9999,
                label: 'OTROS',
                codigoBarras: '', // si no aplica
            }
        ]
        : [];


    const [previewImages, setPreviewImages] = useState({
        imagen_marca: null,
        imagen_modelo: null,
        imagen_serial: null
    });

    const propiedadOpciones = [
        { id: 'Propio', value: 'Propio', label: 'Propio' },
        { id: 'Alquilado', value: 'Alquilado', label: 'Alquilado' },
    ];

    const imagenMarcaRef = useRef(null);
    const imagenModeloRef = useRef(null);
    const imagenSerialRef = useRef(null);


    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        await getTipoEquipo(); getEstadoEquipo(); getVCentroCosto(); getTipoEquipoMenorUIT();getAreaOrganigrama();
        setOpenLoader(false);
    };

    useEffect(() => {
        if (formData?.persona_id) {
            getJefesTrabajador();
        }
    }, [formData?.persona_id]);
    
  /* useEffect(() => {
        if (jefesWorker?.length && jefesWorker[jefesWorker.length - 1]?.id_jefe) {
          const ultimo = jefesWorker[jefesWorker.length - 1];
          const jefeSeleccionado = jefes.find(j => +j.persona_id === +ultimo.id_jefe);
      
          setFormData(prev => ({
            ...prev,
            id_jefe: jefeSeleccionado ? jefeSeleccionado.CodJefe : '',
          }));
        } else {
          // Limpia el campo si no hay datos válidos
          setFormData(prev => ({
            ...prev,
            id_jefe: '',
          }));
        }
      }, [jefesWorker, jefes]);
    */ 

    const handleImageUploadGeneral = (event) => {
        const file = event.target.files[0];

        if (file && file instanceof Blob) {
            setFileGeneral(file);

            const fileType = file.type;
            const fileUrl = URL.createObjectURL(file);

            if (fileType.startsWith('image/')) {
                setImageGeneral([{ url: fileUrl, type: 'image' }]);
            } else if (fileType === 'application/pdf') {
                setImageGeneral([{ url: fileUrl, type: 'pdf' }]);
            } else {
                console.error("Tipo de archivo no soportado.");
            }
        } else {
            console.error("Archivo no válido para la carga.");
        }
    };

    const handleSpecificImageUpload = (e, field) => {
        const file = e.target.files[0];

        if (file && file instanceof Blob) {
            setFormData(prev => ({ ...prev, [field]: file }));
            setPreviewImages(prev => ({ ...prev, [field]: URL.createObjectURL(file) }));
        } else {
            console.error(`Archivo no válido para el campo ${field}.`);
        }
    };


    const sentForm = async (e) => {
        e.preventDefault();

      
        if (!formData?.id_tipoEquipo || formData?.id_tipoEquipo === '') {
            Toast.fire({ icon: 'warning', title: "Debe elegir un  tipo de equipo" });
            return;
        }

        if (formData.id_tipoEquipo === 9999) {
            if (!formData.id_tipoEquipoOtro || formData.id_tipoEquipoOtro === '') {
              alert('Debe seleccionar un equipo de la lista "Otros equipos".');
              return;
            }
            formData.id_tipoEquipo = formData.id_tipoEquipoOtro;
        }

        const dataI = new FormData();
        if (fileGeneral) dataI.append("file", fileGeneral);
        for (const [key, value] of Object.entries(formData)) {
            dataI.append(key, value);
        }



        try {
            setOpenLoader(true);
            setMessageLoader('Guardando información ...');
            const result = await ActiveService.createEquipoRecibido(dataI);

            let icon = result.status === CODES.CREATE_201 ? 'success' : 'error';
            let title = result?.data?.message || result?.response?.data?.error || "Resultado desconocido";

            if (result.status === CODES.CREATE_201) cleanInfo();

            Toast.fire({ icon, title });
        } catch (error) {
            console.error(`Error en sentForm: ${error}`);
        } finally {
            setOpenLoader(false);
            setMessageLoader(null);
        }
    };

    const cleanInfo = () => {
        setFormData(newEquipo);
        setFileGeneral(null);
        setImageGeneral([]);
        setPreviewImages({
            imagen_marca: null,
            imagen_modelo: null,
            imagen_serial: null
        });

        // Resetear los inputs file manualmente
        if (imagenMarcaRef.current) imagenMarcaRef.current.value = null;
        if (imagenModeloRef.current) imagenModeloRef.current.value = null;
        if (imagenSerialRef.current) imagenSerialRef.current.value = null;

    };

    const searchPerson = async (numdoc) => {
        if (!numdoc || numdoc.trim() === '') {
            Toast.fire({ icon: 'warning', title: 'Ingrese un número de documento válido' });
            return;
        }

        setOpenLoader(true);
        setMessageLoader('Buscando Trabajador activo ...');

        try {
            const result = await WorkerService.getTrabajadorActive(numdoc);
            const persona = result?.data;

            if (!persona) {
                Toast.fire({ icon: 'error', title: 'No se encontró la persona' });
                cleanInfo();
                setIsPersonFound(false); setOpenLoader(false);
                return;
            }

            setFormData(prev => ({
                ...prev,
                persona_id: persona.id_persona,
                nombres: persona.nombres,
                apellidos: `${persona.apePaterno} ${persona.apeMaterno}`,
            }));
            setIsPersonFound(true);
          

        } catch (error) {
            console.error(`Error en searchPerson: ${error}`);
            Toast.fire({ icon: 'error', title: 'Ocurrió un error al buscar la persona' });
        }

        setOpenLoader(false);
    };

    const getTipoEquipo = async () => {
        try {
            const result = await GeneralService.getTipoEquipo();
            if (result.status === CODES.SUCCESS_200) {
                result.data.forEach(element => {
                    element.id = element.id_tipoEquipo;
                    element.value = element.id_tipoEquipo;
                    element.label = element.desTipoEquipo;
                    element.codigoBarras = element.codigoBarras;
                });
                setTipoEquipo(result.data);
            }
        } catch (error) {
            console.error(`Error en getTipoEquipo: ${error}`);
        }
    };

    const getTipoEquipoMenorUIT = async () => {
        try {
            const result = await GeneralService.getTipoEquipoMenorUIT();
            if (result.status === CODES.SUCCESS_200) {
                result.data.forEach(element => {
                    element.id = element.id_tipoEquipo;
                    element.value = element.id_tipoEquipo;
                    element.label = element.desTipoEquipo;
                    element.codigoBarras = element.codigoBarras;
                });
                setTipoEquipoMin(result.data);
            }
        } catch (error) {
            console.error(`Error en getTipoEquipo: ${error}`);
        }
    };

    const getEstadoEquipo = async () => {
        try {
            const result = await GeneralService.getEstadoEquipo();
            if (result.status === CODES.SUCCESS_200) {
                result.data.forEach(element => {
                    element.id = element.id_estadoEquipo;
                    element.value = element.id_estadoEquipo;
                    element.label = element.desEstado;
                });
                setEstadoEquipo(result.data);
            }
        } catch (error) {
            console.error(`Error en getEstadoEquipo: ${error}`);
        }
    };

    const getVCentroCosto = async () => {
        try {
            const result = await GeneralService.getVCentroCosto();
            if (result.status === CODES.SUCCESS_200) {
                result.data.forEach(element => {
                    element.id = element.id_centroCosto;
                    element.value = element.id_centroCosto;
                    element.label = element.names;
                    element.code = element.code;
                });
                setCentroCosto(result.data);
            }
        } catch (error) {
            console.error(`Error en getEstadoEquipo: ${error}`);
        }
    };

    const getAreaOrganigrama = async () => {
        try {
            const result = await GeneralService.getAreaOrganigrama();
            if (result.status === CODES.SUCCESS_200) {
                result.data.forEach(element => {
                    element.id = element.CodJefe;
                    element.value = element.CodJefe;
                    element.label = element.Jefe;
                    element.CodJefe = element.CodJefe;
                });
                setJefes(result.data);
            }
        } catch (error) {
            console.error(`Error en getAreaOrganigrama: ${error}`);
        }
    };

    const getJefesTrabajador = async () => {
        try {
            const result = await GeneralService.getJefesTrabajador(formData?.persona_id);
            if (result.status === CODES.SUCCESS_200) {
                result.data.forEach(element => {
                    element.id = element.id_jefe;
                    element.value = element.id_jefe;
                    element.label = element.nombreJefe;
                    element.id_areaOrg = element.id_areaOrg;
                });
                setJefesWorker(result.data);
            }
        } catch (error) {
            console.error(`Error en getJefesTrabajador: ${error}`);
        }
    };
  
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
            <DynamicTitle title="Registrar Equipos" />
            <div className="card" style={{ width: '50rem', margin: "1rem", padding: "0.5rem" }}>
                <div className="card-body">
                    <form onSubmit={sentForm}>
                        <div className='row'>
                            <div className="col-sm-10">
                                <MainInput title="Documento" name="numdoc" type="text"
                                    value={formData.numdoc}
                                    onChange={(e) => setFormData({ ...formData, numdoc: e.target.value })}
                                    required />
                            </div>
                            <div className="col-sm-2 d-flex align-items-end">
                                <button type='button' className='btn btn-outline-dark btn-sm' title='Buscar persona'
                                    onClick={() => searchPerson(formData.numdoc)}>
                                    🔍
                                </button>
                            </div>
                            <div className="col-sm-6">
                                <MainInput title="Apellidos" name="apellidos" value={formData.apellidos} readOnly disabled required />
                            </div>
                            <div className="col-sm-6">
                                <MainInput title="Nombres" name="nombres" value={formData.nombres} readOnly disabled required />
                            </div>
                            <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                                <MainSelectPlus
                                    title="Jefe"
                                    name="id_jefe"
                                    value={formData.id_jefe}
                                    onChange={(e) => setFormData({ ...formData, id_jefe: e.target.value })}
                                    options={jefes}
                                    disabled={!isPersonFound}
                                />
                            </div>
                            <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                            <MainInput title="Telf. jefe" name="telJefe" value={formData.telfJefe}
                                    onChange={(e) => setFormData({ ...formData, telfJefe: e.target.value })} disabled={!isPersonFound} />
                            </div>
                           
                            <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                                <MainSelectPlus
                                    title="Tipo de equipo"
                                    name="equipo_id"
                                    value={formData.id_tipoEquipo}
                                    onChange={(e) => {
                                        const selectedId = parseInt(e.target.value);
                                        const selectedTipo = tipoEquipoConOtros.find(item => item.id_tipoEquipo === selectedId);
                                        setFormData({
                                            ...formData,
                                            id_tipoEquipo: selectedId,
                                            codigoEquipo: selectedTipo ? selectedTipo.codigoBarras : ''
                                        });
                                    }}
                                    options={tipoEquipoConOtros}
                                    disabled={!isPersonFound}
                                />
                            </div>

                            {formData.id_tipoEquipo === 9999 && (
                                <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                                    <MainSelectPlus
                                        title="Otros equipos"
                                        name="equipo_id"
                                        value={formData.id_tipoEquipoOtro}
                                        onChange={(e) => {
                                            const selectedTipo = tipoEquipoMin.find(item => item.id_tipoEquipo === parseInt(e.target.value));
                                            setFormData({
                                                ...formData,
                                                id_tipoEquipoOtro: parseInt(e.target.value),
                                                codigoEquipo: selectedTipo ? selectedTipo.codigoBarras : ''
                                            });
                                        }}
                                        options={tipoEquipoMin}
                                        disabled={!isPersonFound}
                                    />
                                </div>
                            )}

                            <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                                <MainSelectPlus title="Estado del equipo" name="estadoEquipo_id" value={formData.id_estadoEquipo}
                                    onChange={(e) => setFormData({ ...formData, id_estadoEquipo: parseInt(e.target.value) })}
                                    options={estadoEquipo} disabled={!isPersonFound} />
                            </div>
                            <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                                <MainSelectPlus
                                    title="Propiedad del equipo"
                                    name="propiedad"
                                    value={formData.propiedad}
                                    onChange={(e) => setFormData({ ...formData, propiedad: e.target.value })}
                                    options={propiedadOpciones}
                                    disabled={!isPersonFound}
                                />
                            </div>
                            <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                                <MainSelectPlus title="Operación" name="centroCosto" value={formData.id_centroCosto}
                                    onChange={(e) => {
                                        const selectedId = parseInt(e.target.value);
                                        const selectedItem = centroCosto.find(item => item.id === selectedId);
                                        if (selectedItem) {
                                            setFormData({
                                                ...formData,
                                                id_centroCosto: selectedId,                  // para que el select siga funcionando
                                                centroCosto: selectedItem.label + selectedItem.code      // nuevo campo con el nombre
                                            });
                                        }
                                    }}
                                    options={centroCosto} disabled={!isPersonFound} />
                            </div>
                            <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                                <MainInput title="Marca" name="marca" value={formData.marca}
                                    onChange={(e) => setFormData({ ...formData, marca: e.target.value })} disabled={!isPersonFound} />
                                <h6 className="mt-2">Imagen 01</h6>
                                <input type="file" accept="image/*" className="form-control mt-1"
                                    onChange={(e) => handleSpecificImageUpload(e, 'imagen_marca')} disabled={!isPersonFound} ref={imagenMarcaRef} />
                                {previewImages.imagen_marca && <img src={previewImages.imagen_marca} className="img-thumbnail mt-2" height={100} />}
                            </div>
                            <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                                <MainInput title="Modelo" name="modelo" value={formData.modelo}
                                    onChange={(e) => setFormData({ ...formData, modelo: e.target.value })} disabled={!isPersonFound} />
                                <h6 className="mt-2">Imagen 02</h6>

                                <input type="file" accept="image/*" className="form-control mt-1"
                                    onChange={(e) => handleSpecificImageUpload(e, 'imagen_modelo')} disabled={!isPersonFound} ref={imagenModeloRef} />
                                {previewImages.imagen_modelo && <img src={previewImages.imagen_modelo} className="img-thumbnail mt-2" height={100} />}
                            </div>

                            <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                                <MainInput title="Serial" name="serial" value={formData.serial}
                                    onChange={(e) => setFormData({ ...formData, serial: e.target.value })} disabled={!isPersonFound} />
                                <h6 className="mt-2">Imagen 03</h6>
                                <input type="file" accept="image/*" className="form-control mt-1"
                                    onChange={(e) => handleSpecificImageUpload(e, 'imagen_serial')} disabled={!isPersonFound} ref={imagenSerialRef} />
                                {previewImages.imagen_serial && <img src={previewImages.imagen_serial} className="img-thumbnail mt-2" height={100} />}
                            </div>

                            <div className="w-100"></div>
                            <div className="col-sm-6" style={{ paddingTop: '1.5rem' }}>
                                <MainInput title="Departamento" name="departamento" value={formData.departamento}
                                    onChange={(e) => setFormData({ ...formData, departamento: e.target.value })} disabled={!isPersonFound} />
                            </div>
                            <div className="col-sm-6" style={{ paddingTop: '1.5rem' }}>
                                <MainInput title="Distrito" name="distrito" value={formData.distrito}
                                    onChange={(e) => setFormData({ ...formData, distrito: e.target.value })} disabled={!isPersonFound} />
                            </div>
                            <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                                <MainInput title="Direccion" name="direccion" value={formData.direccion}
                                    onChange={(e) => setFormData({ ...formData, direccion: e.target.value })} disabled={!isPersonFound} />
                            </div>
                            <div className="col-sm-6" style={{ paddingTop: '1rem' }}>
                                <MainInput title="Lugar físico" name="lugar" value={formData.lugar}
                                    onChange={(e) => setFormData({ ...formData, lugar: e.target.value })} disabled={!isPersonFound} />
                            </div>

                            <div className="col-sm-6" style={{ paddingTop: '1.5rem' }}>
                                <div className="form-group">
                                    <label>Tiempo de vida a opinión del usuario"</label>
                                    <div className="row">
                                        <div className="col-6">
                                            <MainInput type="number" title="Años" min="0"
                                                value={formData.tiempoVidaAnios || ''}
                                                onChange={(e) => setFormData({ ...formData, tiempoVidaAnios: e.target.value })}
                                                disabled={!isPersonFound}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <MainInput
                                                type="number"
                                                title="Meses"
                                                placeholder="Meses"
                                                min="0"
                                                value={formData.tiempoVidaMeses || ''}
                                                onChange={(e) => {
                                                    let meses = parseInt(e.target.value, 10) || 0;
                                                    let anios = parseInt(formData.tiempoVidaAnios, 10) || 0;

                                                    if (meses >= 12) {
                                                        anios += Math.floor(meses / 12);
                                                        meses = meses % 12;
                                                    }

                                                    setFormData({
                                                        ...formData,
                                                        tiempoVidaAnios: anios,
                                                        tiempoVidaMeses: meses
                                                    });
                                                }}
                                                disabled={!isPersonFound}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div style={{ paddingTop: '1rem' }}>
                                <MainInputImage title="Seleccione imagen general"
                                    handleFilesChange={handleImageUploadGeneral}
                                    allowedFileTypes="image/*,application/pdf" disabled={!isPersonFound} />
                                <Carousel>
                                    {imageGeneral.map((file, i) => (
                                        <Carousel.Item key={i}>
                                            {file.type === 'image' ? (
                                                <img src={file.url} className="d-block w-100 card-img-top" alt={`Slide ${i}`} height={600} />
                                            ) : file.type === 'pdf' ? (
                                                <iframe src={file.url} className="d-block w-100" height="300" title={`PDF ${i}`}></iframe>
                                            ) : null}
                                        </Carousel.Item>
                                    ))}
                                </Carousel>
                            </div>
                            <div className="col-sm-12">
                                <div className="form-group">
                                    <legend className='title-legend'>Otros datos</legend>
                                    <textarea className="form-control" name="descripcion" rows={4}
                                        value={formData.otros}
                                        onChange={(e) => setFormData({ ...formData, otros: e.target.value })}
                                        disabled={!isPersonFound} />
                                </div>
                            </div>
                            <div className="col-md-12 mt-4 mb-2 d-flex justify-content-center">
                                <button type="submit" className="btn btn-primary">Subir</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* Tabla flotante al costado derecho */}
            <div
                className="d-none d-md-block"
                style={{
                    position: "fixed",
                    top: "2rem",
                    right: "1%",
                    width: "20rem",
                    zIndex: 10,
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    padding: "0.5rem",
                    boxShadow: "0 0 8px rgba(0,0,0,0.1)",
                }}
            >
                <table className="table table-bordered table-sm text-center w-100 mb-0">
                    <thead className="text-center">
                        <tr>
                            <th>Año</th>
                            <th>UIT</th>
                            <th>1/4 de UIT</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td>2025</td><td>5350</td><td>1,337.50</td></tr>
                        <tr><td>2024</td><td>5150</td><td>1,287.50</td></tr>
                        <tr><td>2023</td><td>4950</td><td>1,237.50</td></tr>
                        <tr><td>2022</td><td>4600</td><td>1,150.00</td></tr>
                        <tr><td>2021</td><td>4400</td><td>1,100.00</td></tr>
                        <tr><td>2020</td><td>4300</td><td>1,075.00</td></tr>
                    </tbody>
                </table>
            </div>


            <Loader open={openLoader} message={messageLoader} />
        </div>
    );

};

export default EquipmentRegister;
